<template>
  <q-layout view="hHh lpR fFf">
    <q-header
      bordered
      class="bg-page"
    />

    <q-page-container>
      <q-page
        class="flex flex-center q-mx-auto content-around text-center"
      >
        <div class="fit row wrap justify-start items-start content-center">
          <div class="col-12">
            <img
              alt="Comptacrypto logo"
              class="inline"
              :src="
                $q.dark.isActive
                  ? 'logos/cc_logo_dark.svg'
                  : 'logos/cc_logo_light.svg'
              "
              style="width: 400px"
            >
          </div>
        </div>

        <div class="fit row wrap justify-center items-center content-center">
          <div class="col-12">
            <img
              class="inline"
              alt="Illustration mailbox"
              src="/illustrations/verify.svg"
              style="max-width: 360px; width: 100%"
            >
          </div>
          <div class="text-h4 col-12">
            <h4 class="q-my-md">
              {{ i18n.title }}
            </h4>
          </div>

          <div class="col-12 text-body2">
            <span v-html="i18n.caption_title" />
            <br>
            <span class="text-grey-6 text-caption">
              {{ i18n.caption_text }}
            </span>
          </div>

          <div class="col-12 text-caption q-mt-xl">
            <span class="caption">
              {{ i18n.text }}
              <q-btn
                flat
                class="href-link underline"
                :disable="email_confirmation_resend_loading"
                :loading="email_confirmation_resend_loading"
                @click.prevent="email_confirmation_resend"
              >
                {{ i18n.send_email_action_label }}
              </q-btn>
              {{ i18n.send_email_text }}
            </span>
          </div>
        </div>

        <div class="fit row wrap justify-center items-center content-center">
          <q-btn
            flat
            color="dark"
            :label="i18n.logout_action_label"
            icon-right="las la-sign-out-alt"
            :href="logout_action_path"
          />
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>

export default {
  components: {
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    resend_confirmation_email_path: {
      type: String,
      required: true,
    },
    logout_action_path: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      email_confirmation_resend_loading: false,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    email_confirmation_resend() {
      this.$inertia.post(
        this.resend_confirmation_email_path,
        {},
        {
          onStart: () => {
            this.email_confirmation_resend_loading = true;
          },
          onSuccess: () => {
            this.$q.notify({
              message: this.$page.props.flash.success,
              type: 'positive',
            });
          },
          onError: (errors) => {
            console.log(errors);
            this.$q.notify({
              message: this.$page.props.flash.alert,
              type: 'negative',
            });
          },
          onFinish: () => {
            this.email_confirmation_resend_loading = false;
          }
        }
      );
    }
  }
};
</script>
